<template>
    <section class="timetable">
            <h2 class="timetable__title">Страница не найдена</h2>
    </section>
</template>
<script>
export default{

}
</script>
